export default class ArticleSpeechTimeSupporter {
  private articleId: number;
  private speechTime: number;
  private lastTime: number;

  constructor(articleId) { // eslint-disable-line @typescript-eslint/explicit-module-boundary-types
    this.articleId = articleId;
    this.reset();
  }

  reset() { // eslint-disable-line @typescript-eslint/explicit-module-boundary-types
    this.speechTime = 0;
    this.lastTime = 0;
  }

  countUp(event: SpeechSynthesisEvent) { // eslint-disable-line @typescript-eslint/explicit-module-boundary-types
    // MEMO: ArticleSpeech.vueの仕様上、音量変更などでSpeechSynthesisUtteranceが作り直される可能性あるため
    //       インスタンスが変わっていないか確認している
    // MEMO: 小数点以下は不要なので切り捨てる
    if (this.lastTime <= event.elapsedTime) {
      const time = Math.floor(event.elapsedTime) - Math.floor(this.lastTime);
      this.speechTime += time;
    } else {
      this.speechTime += Math.floor(event.elapsedTime);
    }
    this.lastTime = event.elapsedTime;
  }

  complete() { // eslint-disable-line @typescript-eslint/explicit-module-boundary-types
    // 読み上げ時間が0の場合はサーバーにリクエストする必要がないためreturn
    if (this.speechTime === 0) return;

    // view_timeを保存するために使用しているsendbeacon メソッドがieは対応していない
    // https://developer.mozilla.org/en-US/docs/Web/API/Navigator/sendBeacon
    const ua = window.navigator.userAgent.toLowerCase();
    if (ua.indexOf("windows nt 6.1") !== -1) { return; }

    // ブラウザの離脱イベント時はsendBeaconを使用する
    // ref: https://madogiwa0124.hatenablog.com/entry/2019/10/19/225859
    // sendBeaconでエラーになることがあるためrefの書き方に変えた
    // ref: https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
    if(navigator.sendBeacon != null) {
      try {
        const sendBeacon = window.navigator.sendBeacon.bind(navigator);
        const params = this.createParams();
        const result = sendBeacon("/api/v1/article_speech_times", params);
        // sendBeacon() メソッドがfalseを返した場合はbugsnagに通知する
        // ref: https://developer.mozilla.org/ja/docs/Web/API/Navigator/sendBeacon#return_values
        if (!result) {
          window.webpackBugsnagClient.notify("読み上げ時間の保存に失敗しました。");
        }
      } catch (e) {
        // sendBeaconでエラーが発生する可能性があるため例外処理を入れる
        // Illegal invocationエラーの場合は確認に時間がかかるためbugsnagに送らない
        // ref: https://github.com/radicodeinc/value_press/issues/13452
        if (e.message === "Illegal invocation") { return; }

        window.webpackBugsnagClient.notify("view_timeの保存に失敗しました。" + JSON.stringify(e, ["message", "arguments", "type", "name"]));
      }
    } else {
      window.webpackBugsnagClient.notify("読み上げ時間の保存に失敗しました。");
    }

    this.reset();
  }

  private createParams() {
    const params = new FormData();
    params.append("article_id", this.articleId.toString());
    params.append("speech_time", this.speechTime.toString());
    return params;
  }
}
